import { combineReducers } from 'redux';
import editGallery from 'modules/products/reducers/editGallery';
import lookEdits from './looks';
import editPDP from './editPDP';

const looksModule = combineReducers({
  lookEdits,
  editGallery,
  editPDP,
});

export default looksModule;
